export class OfferGridModel {
  public id: number;
  public remoteId: number;
  public offerStatusId: number;
  public offerNumber: string;
  public offerDate: string;
  public traderName: string;
  public managerName: string;
  public clientName: string;
  public clientTown: string;
  public clientAddress: string;
  public offerPrice: number;
  public boilerMake: string;
  public reported: boolean;
  public priceChanged: boolean;
}